import { store } from '@betacrew/jars-flux'
export const componentKey = "STATEPAYROLLFILING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setStateList: (state, action) => {
            state.stateList = action.payload;
        },
        setSelectedState: (state, action) => {
            state.selectedState = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setStatePayrollHistoryGridData: (state, action) => {
            state.statePayrollHistoryGridData = action.payload;
        },
        setSelectedStatePayrollHistoryGridData: (state, action) => {
            state.selectedStatePayrollHistoryGridData = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip: (state, action) => {
            state.skip = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setUrlFormIdParam: (state, action) => {

            state.urlFormIdParam = action.payload;
        },
        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        },
    },
    initialReducerState: {
        stateList: [{ label: 'Select State', value: 0 }],
        selectedState: [{ label: 'Select State', value: 0 }],
        formList: [{ label: 'Select Form', value: 0 }],
        selectedForm: [{ label: 'Select Form', value: 0 }],
        taxYearList: [{ label: 'Select TaxYear', value: 0 }],
        selectedTaxYear: [{ label: 'Select TaxYear', value: 0 }],
        payerList: [{ label: 'Select Payer', value: 0 }],
        selectedPayer: [{ label: 'Select Payer', value: 0 }],
        statePayrollHistoryGridData: [],
        selectedStatePayrollHistoryGridData: 0,
        rowsPerPage: 10,
        skip: 0,
        loadingState: false,
        urlFormIdParam: null,
        urlPayerIdParam: null,
    }
});
export const { setStateList, setSelectedState, setFormList, setSelectedForm, setTaxYearList, setSelectedTaxYear, setPayerList, setSelectedPayer, setStatePayrollHistoryGridData, setSelectedStatePayrollHistoryGridData, setRowsPerPage, setSkip, setLoadingState, setUrlFormIdParam, setUrlPayerIdParam } = actions;